/* CUSTOM_BLOGBOT_BY_CLAUDE — behavior for the native hotspot circles
   ("Product features" / "Shoppable image"), matching the blog hotspots:
     1. 50ms haptic tap feedback (Android; iOS/desktop are no-ops).
     2. The "x" star reticle spins while hovered (desktop) or open (touch), then
        DECELERATES to a stop when you leave / close it (Web Animations, mirrors
        startSpin/stopSpin in bb-hotspot.js) — never snaps back, never sticks.
   Pure add-on: the theme's hotspots-image.js still owns open/close. Bound once. */
(function () {
  if (window.__bbNativeHotspots) return;
  window.__bbNativeHotspots = true;

  // ── 1. Haptics ──────────────────────────────────────────────────────────
  document.addEventListener(
    'click',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.hotspot__btn')) {
        try {
          if (navigator.vibrate) navigator.vibrate(50);
        } catch (err) {}
      }
    },
    true
  );

  // ── 2. Star spin (Web Animations) ───────────────────────────────────────
  var SPIN_MS = 3000; // slow, steady rotation
  var BASE = 'translate(-50%,-50%) '; // the star is centered via this transform
  var prefersReduced = false;
  try {
    prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}
  var spins = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function startSpin(dot) {
    if (prefersReduced || !dot || !dot.animate || !spins) return;
    var s = spins.get(dot);
    if (s && s.mode === 'spin') return; // already spinning
    if (s && s.anim) {
      try { s.anim.cancel(); } catch (e) {} // cancel a decel in progress
    }
    var anim = dot.animate(
      [
        { transform: BASE + 'rotate(0deg)' },
        { transform: BASE + 'rotate(360deg)' }
      ],
      { duration: SPIN_MS, iterations: Infinity, easing: 'linear' }
    );
    spins.set(dot, { anim: anim, mode: 'spin' });
  }

  function stopSpin(dot) {
    if (!dot || !spins) return;
    var s = spins.get(dot);
    if (!s || s.mode !== 'spin') return; // not spinning (or already decelerating)
    var anim = s.anim, cur = 0;
    try { cur = (((anim.currentTime || 0) % SPIN_MS) / SPIN_MS) * 360; } catch (e) {}
    try { anim.cancel(); } catch (e) {}
    var target = Math.ceil(cur / 360) * 360; // continue FORWARD to the next full turn
    if (target - cur < 200) target += 360; // guarantee a visible wind-down
    var dec = dot.animate(
      [
        { transform: BASE + 'rotate(' + cur + 'deg)' },
        { transform: BASE + 'rotate(' + target + 'deg)' }
      ],
      { duration: 1100, easing: 'cubic-bezier(0.2,0.8,0.25,1)', fill: 'none' } // ease-out momentum stop
    );
    spins.set(dot, { anim: dec, mode: 'decel' });
    dec.onfinish = function () {
      var cs = spins.get(dot);
      if (cs && cs.anim === dec) spins.delete(dot);
    };
  }

  function iconOf(hotspot) {
    return hotspot ? hotspot.querySelector('.hotspot__btn .icon') : null;
  }
  // spin while hovered OR open; stop only when neither is true
  function refresh(hotspot) {
    var dot = iconOf(hotspot);
    if (!dot) return;
    if (hotspot.__bbHover || hotspot.classList.contains('is-active')) startSpin(dot);
    else stopSpin(dot);
  }

  function bind(hotspot) {
    if (hotspot.__bbSpinBound) return;
    var btn = hotspot.querySelector('.hotspot__btn');
    if (!btn) return;
    hotspot.__bbSpinBound = true;

    btn.addEventListener('mouseenter', function () {
      hotspot.__bbHover = true;
      refresh(hotspot);
    });
    btn.addEventListener('mouseleave', function () {
      hotspot.__bbHover = false;
      refresh(hotspot);
    });
    // open/close (touch tap, click-outside, Escape, resize) toggles .is-active
    try {
      new MutationObserver(function () {
        refresh(hotspot);
      }).observe(hotspot, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  function init() {
    document.querySelectorAll('hotspots-image .hotspot').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-bind sections added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
  window.BBNativeHotspots = { init: init };
})();
